<template>
  <v-container fluid>
    <alert-error :error="error" />

    <v-toolbar>
      <v-toolbar-title>{{ $t('REQUEST_VACATIONS.ITEMS') }}</v-toolbar-title>

      <v-spacer />

      <v-btn dark color="indigo" @click="$router.go(-1)">
        {{ $t('BUTTON.BACK') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <request-vacations-filter-form @setFilters="setFilters" />

      <request-vacations-list
        :meta="meta"
        :request-vacations="requestVacations"
        :options.sync="options"
        @show="show"
      />

      <v-dialog v-if="dialog" v-model="dialog" persistent max-width="1200">
        <edit-request-vacation
          :data="component.data"
          @cancel="cancelDialog"
          @updated="cancelDialogAndRefresh"
        />
      </v-dialog>
    </v-sheet>
  </v-container>
</template>

<script>
import DataOptions from '@/modules/_global/classes/DataOptions';
import { cloneDeep, debounce, isEmpty } from 'lodash';
import { mapActions, mapState } from 'vuex';
import RequestVacationsFilterForm from '@/modules/request_vacations/components/forms/RequestVacationsFilterForm.vue';
import RequestVacationsList from '@/modules/request_vacations/components/RequestVacationsList.vue';
import EditRequestVacation from '@/modules/request_vacations/components/EditRequestVacation.vue';

const DEBOUNCE_DELAY = 300;

export default {
  name: 'RequestVacationsPage',

  components: {
    EditRequestVacation,
    RequestVacationsList,
    RequestVacationsFilterForm,

    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  data() {
    return {
      error: null,
      requestVacations: [],
      meta: {
        total: 0
      },
      options: {
        page: 1,
        itemsPerPage: 100,
        sortBy: ['created_at'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      filters: {},
      dialog: false,
      component: null
    };
  },

  computed: {
    ...mapState('request_vacations', [
      'requestVacationsFilters',
      'requestVacationsPaginationOptions'
    ]),

    preparedOptions() {
      return DataOptions.createFromObject(this.options).toBackendFormat();
    },

    params() {
      return Object.assign(
        {},
        { paginationOptions: this.preparedOptions },
        { filters: this.filters }
      );
    }
  },

  watch: {
    options: {
      handler() {
        this.refreshData();
      },
      deep: true
    }
  },

  mounted() {
    if (!isEmpty(this.requestVacationsPaginationOptions)) {
      this.options = cloneDeep(this.requestVacationsPaginationOptions);
    }
  },

  methods: {
    ...mapActions('request_vacations', ['getRequestVacations']),

    getRequestVacationsData: debounce(function debouncedGetRequestVacations() {
      this.getRequestVacations({ params: this.params })
        .then(({ data: { meta, data } }) => {
          this.meta = meta;
          this.requestVacations = data;
        })
        .catch(error => {
          this.error = error;
        });
    }, DEBOUNCE_DELAY),

    refreshData() {
      this.getRequestVacationsData();
    },

    setFilters(v) {
      this.filters = v;
      this.options.page = 1;
      this.refreshData();
    },

    show(item) {
      this.dialog = true;

      this.component = {
        name: 'EditRequest',
        data: item
      };
    },

    cancelDialog() {
      this.dialog = false;
      this.component = null;
    },

    cancelDialogAndRefresh() {
      this.cancelDialog();
      this.refreshData();
    }
  }
};
</script>
